import { useQuery } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useSystemLanguages = () => {
  const fetchContext = useContext(FetchContext);

  return useQuery("languages", async () => {
    const { data } = await fetchContext.authAxios.get(`/languages`);
    return data;
  });
};
